import React from 'react';
import { withRouter } from "react-router-dom";

import {CardTextArrow} from "../../components";
import Colors from "../../constants/Colors";


const JourneyPerformanceComponent = (props) => {

    return (
        <CardTextArrow
            text={props.title}
            showArrow={true}
            onPress={() => props.history.push(`/performance/details?journeyId=${props.id}` )}
            containerStyle={{ backgroundColor: Colors.backgroundColor, borderBottomWidth: 0.4, borderColor: 'gray' }}
            textStyle={{ color: Colors.fontColorOnBackground }}
            arrowColor={'black'}
        />
    )
}

export default withRouter(JourneyPerformanceComponent) ;
